"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var styles_1 = require("./styles");
var Field = function (_a) {
    var _b = _a.as, Component = _b === void 0 ? 'input' : _b, variant = _a.variant, _c = _a.inputProps, inputProps = _c === void 0 ? {} : _c, secured = _a.secured, forwardedRef = _a.forwardedRef, props = __rest(_a, ["as", "variant", "inputProps", "secured", "forwardedRef"]);
    var inputRef = (0, react_1.useRef)(null);
    var focus = (0, react_1.useCallback)(function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var blur = (0, react_1.useCallback)(function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, []);
    var isFocus = (0, react_1.useCallback)(function () {
        return inputRef.current === document.activeElement;
    }, []);
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({ focus: focus, blur: blur, isFocus: isFocus }); });
    var textAreaClassName;
    var typeProp = {};
    if (Component === 'textarea') {
        textAreaClassName =
            variant === 'multi-line' ? 'squid-resize-none' : 'squid-resize-y';
    }
    else {
        typeProp = { type: secured ? 'password' : 'text' };
    }
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, typeProp, inputProps, props, { ref: inputRef, className: (0, classnames_1.default)(styles_1.fieldClassName, textAreaClassName) })));
};
exports.default = Field;
